import React from 'react';
import {View} from 'react-native';
import {get} from 'lodash';

import Text from '/component/base/Text';
import {darkGray} from '/theme/color/on.color';
import {getFontFamily} from '/util/text.util';

import {styles} from '../BottomTabNavigation.style';

export const renderBarLabel =
  ({routeName, tabs}: any) =>
  (options = {}) => {
    const color = get(options, 'color', darkGray);
    const focused = get(options, 'focused', false);

    const tab = tabs.find(({name}: any) => name === routeName) || {};

    const textStyle = {
      ...styles.tabBarTabText,
      ...(focused ? getFontFamily('bold') : getFontFamily('regular')),
      color,
    };

    return (
      <View style={styles.tabBarTabLabelContainer} accessible={false}>
        <Text style={textStyle} truncate>
          {tab.label}
        </Text>
      </View>
    );
  };
